var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisaIncLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 14,
    viewBox: "0 0 44 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_107_123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.7454 13.7985H15.2412L17.433 0.246094H20.937L18.7454 13.7985Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4482 0.576978C30.757 0.302765 29.6608 0 28.3052 0C24.8447 0 22.4078 1.84533 22.3929 4.4836C22.3641 6.43011 24.1376 7.51125 25.464 8.16028C26.8197 8.82349 27.2806 9.25637 27.2806 9.84752C27.2668 10.7554 26.1851 11.1739 25.1762 11.1739C23.7771 11.1739 23.0275 10.9582 21.8883 10.4531L21.4269 10.2365L20.9365 13.2787C21.7584 13.6532 23.2726 13.9854 24.8447 14C28.5215 14 30.9153 12.1832 30.9437 9.37172C30.9577 7.82897 30.0212 6.64684 28.0022 5.68087C26.7766 5.06077 26.026 4.64265 26.026 4.00819C26.0404 3.4314 26.6609 2.84062 28.0444 2.84062C29.1836 2.81169 30.0206 3.08552 30.6547 3.35954L30.9716 3.50345L31.4482 0.576978Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1052 8.99734C36.3938 8.21878 37.5042 5.2055 37.5042 5.2055C37.4897 5.23443 37.7922 4.41256 37.9653 3.90802L38.2102 5.07577C38.2102 5.07577 38.8738 8.31976 39.0179 8.99734C38.4702 8.99734 36.7973 8.99734 36.1052 8.99734ZM40.4307 0.246094H37.7202C36.8843 0.246094 36.2493 0.490988 35.8887 1.37054L30.6836 13.7983H34.3605C34.3605 13.7983 34.9658 12.1256 35.0959 11.7653C35.4993 11.7653 39.0761 11.7653 39.595 11.7653C39.6956 12.2411 40.0132 13.7983 40.0132 13.7983H43.2577L40.4307 0.246094Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3137 0.246094L8.88193 9.48751L8.50692 7.61325C7.87246 5.45058 5.88264 3.1009 3.66211 1.93257L6.8055 13.7841H10.5111L16.0191 0.246094H12.3137Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69562 0.246094H0.0576784L0 0.519923C4.39795 1.64456 7.31062 4.35546 8.50731 7.61382L7.28169 1.38529C7.07991 0.519732 6.45982 0.274646 5.69562 0.246094Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_107_123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.2582,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaIncLogo1);
export default __webpack_public_path__ + "static/media/Visa_Inc_logo-1.2feac8836db49543af5e17b2de8deb4f.svg";
export { ForwardRef as ReactComponent };